import {
  FormControl,
  ListItemText,
  ListSubheader,
  MenuItem,
  OutlinedInput,
  Select,
  Switch,
} from "@mui/material";
import buildNavLinksFromBackendTabs from "../navLinks/Navlinks";

const RoleTabsSelect = ({
  selectedTabs,
  tabs = [],
  tabsLoading = false,
  onTabToggle,
}) => {
  const navSections = buildNavLinksFromBackendTabs(tabs).filter(
    (section) => section.tabs.length > 0
  );
  const visibleTabs = navSections.flatMap((section) => section.tabs);
  const selectedTabNames = selectedTabs
    .map((tabId) => visibleTabs.find((tab) => tab.id === tabId)?.title)
    .filter(Boolean);

  return (
    <FormControl
      style={{ width: "100%", marginTop: "10px" }}
      sx={{
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            border: "none",
            borderRadius: "none",
            borderBottom: "1px solid black",
          },
          "&:hover fieldset": {
            borderColor: "transparent",
          },
          "&.Mui-focused fieldset": {
            borderColor: "transparent",
            boxShadow: "none",
            borderBottom: "1px solid #000000",
            marginBottom: "1px",
          },
        },
      }}
    >
      <Select
        multiple
        displayEmpty
        value={selectedTabs}
        onChange={() => {}}
        input={<OutlinedInput />}
        renderValue={() =>
          selectedTabNames.length > 0 ? selectedTabNames.join(", ") : "Select tabs"
        }
        disabled={tabsLoading}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 360,
              width: 320,
            },
          },
        }}
      >
        {navSections.flatMap((section) => [
          <ListSubheader
            key={`${section.sectionKey}-header`}
            disableSticky
            sx={{
              color: "#37446F",
              fontWeight: 700,
              lineHeight: "36px",
              background: "#EAF1F7",
            }}
          >
            {section.tag}
          </ListSubheader>,
          ...section.tabs.map((tab) => (
            <MenuItem
              key={tab.id}
              value={tab.id}
              onClick={() => onTabToggle(tab.id)}
              sx={{ paddingLeft: "24px" }}
            >
              <ListItemText primary={tab.title} style={{ float: "left" }} />
              <Switch
                checked={selectedTabs.includes(tab.id)}
                onClick={(event) => event.stopPropagation()}
                onChange={() => onTabToggle(tab.id)}
                max={1}
                step={1}
                sx={{
                  textAlign: "right",
                  "&.MuiSwitch-root .Mui-checked": {
                    color: "#37446F",
                  },
                }}
              />
            </MenuItem>
          )),
        ])}
      </Select>
    </FormControl>
  );
};

export default RoleTabsSelect;
